var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-toolbar" }, [
    _vm.cleared
      ? _c(
          "button",
          {
            staticClass: "swb-btn swb-btn-small fl mr10",
            on: {
              click: function($event) {
                _vm.doCleared()
              }
            }
          },
          [_vm._v("清理")]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.scrapped && !_vm.cleared ? _c("div", [_vm._v("无操作")]) : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25f27a8c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25f27a8c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/AssetQuickOption.vue
// module id = 3087
// module chunks = 0